export default __webpack_public_path__ + "static/media/textBinIcon.a1eeebf5.svg";